import classNames from 'classnames'
import { Link } from 'gatsby'
import React, { useContext } from 'react'

import { LocaleContext } from '../locale/i18n'
import { staticPagePaths } from '../locale/pathing'
import { StaticPage } from '../logic/staticPage'

import { EmailLink } from './EmailLink'
import IconEmail from './icons/IconEmail'
import IconPhone from './icons/IconPhone'

import './ContactBanner.scss'

const ContactBanner = ({
  className,
  compact = false,
}: {
  className?: string
  compact?: boolean
}) => {
  const { locale, t } = useContext(LocaleContext)

  return (
    <div className={classNames('contactBanner', className)}>
      <div style={{ flex: 1 }}>
        <h2 className="contactBanner__heading">{t('contactBanner.heading')}</h2>
        <div className="contactBanner__contactList">
          <div>
            <div className="contactBanner__row">
              <IconEmail className="contactBanner__icon" />
              <EmailLink
                className="contactBanner__rowText"
                email="info@measurlabs.com"
                location="contactBanner"
              >
                info@measurlabs.com
              </EmailLink>
            </div>
            <div className="contactBanner__row">
              <IconPhone className="contactBanner__icon" />
              <Link
                className="contactBanner__rowText"
                to={`${staticPagePaths[StaticPage.CONTACT][locale]}#${t('contact.salesAnchor')}`}
              >
                {t('contactBanner.sales')}
              </Link>
            </div>
          </div>
          {compact && (
            <img
              className="contactBanner__image"
              loading="lazy"
              src="/ringing-phone.svg"
            />
          )}
        </div>
        {!compact && (
          <p className="contactBanner__footer">
            {t('contactBanner.businessHours')}
          </p>
        )}
      </div>
      {!compact && (
        <img
          alt="Ringing phone"
          className="contactBanner__image contactBanner__image--large"
          loading="lazy"
          src="/ringing-phone.svg"
        />
      )}
    </div>
  )
}

export default ContactBanner
